import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { param } from 'jquery';
import { NgxSpinnerService } from 'ngx-spinner';
import { ListRisksMatrix } from 'src/app/web/interfaces/project/list/projectDetailsDto';
import { SummaryInfoDto } from 'src/app/web/interfaces/project/list/summaryInfoDto';
import Swal from 'sweetalert2';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';

class updateRisk{
  id: number;
  project_id        : number;
  project_stages_id : number;
  name              : string;
  description   : string;
  activation_date    : string;
  deadline_date      : string;
  probability       : string;
  impact            : string;
  impact_description        : string;
  users_id            : number;
  username            : string = '';
}


@Component({
  selector: 'app-risks-update',
  templateUrl: './risks-update.component.html',
  styleUrls: ['./risks-update.component.scss']
})
export class RisksUpdateComponent implements OnInit {

  updateRiskForm: FormGroup;
  idProject:number;
  idRisk : number;

  listStage: any[] = [];
  listImpact: any[] =[];
  listProbability: any[] = [];
  listPerson: any[] = [];
  // listRisksMatrix: updateRisk; 

  username : string;
  updateRisk : updateRisk;
  risk : ListRisksMatrix;

  summaryInfoDto: SummaryInfoDto = {} as SummaryInfoDto;

  constructor(private apiService: ApiServiceProject,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private fb: FormBuilder,
              private spinner: NgxSpinnerService,
              private errorService:ErrorService) { 
   this.activatedRoute.params.subscribe(params => {
     this.idProject = params['id'];
     this.idRisk = params['idRisk']
    })
  }

  ngOnInit(): void {

    this.updateRiskForm = this.fb.group({
      project_stages_id :[''],
      name: [''],
      description: [''],
      activation_date: [''],
      deadline_date: [''],
      probability: [''],
      impact: [''],
      impact_description: [''],
      users_id: [''],
    });
    
    this.spinner.show();

    // Validacion y optencion de combobox
    this.apiService.getService(`project-view-risks?id_project=${this.idProject}`)
    .subscribe({
      next: (data:any) =>{

        if (data.code == null) {
          if (data == '' || data == null) {
            this.spinner.hide();
            Swal.fire({
              title: 'No se encontraron registros',
              text: '',
              icon: 'info',
              confirmButtonText: 'Aceptar',
              heightAuto: false
            }).then((res) =>{
              if (res.isConfirmed || res.isDismissed) {
                this.router.navigate(['home']);
              }
            })
          }

          this.listStage = data.listDependence;
          this.listImpact = data.listImpact;
          this.listProbability = data.listProbabilty;
          this.listPerson = data.listAssigned;
          this.dataInfo();
        }else{
          this.spinner.hide();
          Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
        }
      },
      error: (error) => {
        this.errorService.error(error);
      },
    });

  }


  dataInfo(){

    this.summaryInfoDto.title = localStorage.getItem("title");
    let dato = JSON.parse(localStorage.getItem("info-mtn"));
    this.idRisk = dato.id

    this.updateRiskForm.patchValue({
      project_stages_id : dato.idStages,
      name : dato.name,
      description : dato.description,
      activation_date : moment(dato.dateStart, 'DD-MM-YYYY').format("YYYY-MM-DD"), 
      deadline_date : moment(dato.dateEnd, 'DD-MM-YYYY').format("YYYY-MM-DD"), 
      probability : dato.probability,
      impact : dato.impact,
      impact_description : dato.impactDescription,
      users_id : dato.usersId
    });
    this.spinner.hide();
   
  }

  // Validaciones y envios de formulario
  formUpdate(): void {
    this.spinner.show();
      

    if (this.updateRiskForm.value.project_stages_id === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar una etapa' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.updateRiskForm.value.name === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar un nombre para el riesgo' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.updateRiskForm.value.description === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una descripcion' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.updateRiskForm.value.activation_date === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una fecha de activacion' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.updateRiskForm.value.activation_date === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una fecha de deadline' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.updateRiskForm.value.probability === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una probabilidad' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.updateRiskForm.value.impact === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar un impacto' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.updateRiskForm.value.impact_description === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar una descripcion de impacto' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
    if (this.updateRiskForm.value.users_id === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe ingresar un responsable' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    this.updateRisk = new updateRisk();

    this.updateRisk.project_id =  Number(this.idProject);
   
    // this.listPerson.map((dato)=>{ if(dato.id == this.updateRisk.person) { this.username = dato.nombre } })
  
    let name = this.listPerson.filter( n =>  Number(n.users_id) == Number(this.updateRiskForm.value.users_id))

    this.updateRisk.project_stages_id = Number(this.updateRiskForm.value.project_stages_id);
    this.updateRisk.users_id = Number(this.updateRiskForm.value.users_id);
    this.updateRisk.id = Number(this.idRisk);
    this.updateRisk.impact = this.updateRiskForm.value.impact.toString()
    this.updateRisk.probability = this.updateRiskForm.value.probability.toString()
    this.updateRisk.activation_date = moment(this.updateRiskForm.value.activation_date).format("DD-MM-YYYY");
    this.updateRisk.deadline_date = moment(this.updateRiskForm.value.deadline_date).format("DD-MM-YYYY");
    this.updateRisk.username = name[0].username
    this.updateRisk.name = this.updateRiskForm.value.name;
    this.updateRisk.impact_description = this.updateRiskForm.value.impact_description;
    this.updateRisk.description = this.updateRiskForm.value.description;

      this.apiService
      .postService('project-view-risks-update',this.updateRisk)
      .subscribe({
        next: (data:any)=>{
          if(data.message){
          this.spinner.hide();
          // this.listRisksMatrix = this.updateRisk;
          Swal.fire({title:'Se ha actualizado el riesgo correctamente' ,text: '',icon: 'success',heightAuto: false})
          .then(( ) =>[this.router.navigate(['/pdg/project/list/view',this.idProject ])] );
        }else{
          this.spinner.hide();
          Swal.fire({title:data.error ,text: '',icon: 'error',heightAuto: false}).then((dato)=>{
          });
        }

        },
        error: (error) => {
          this.errorService.error(error);
        },
      });
    
    

  }
}
